import { api } from '../../../services/api';
import type { LocalLoginResponse, ProvidersInfo } from '../../../types';

/** Page-level service for the login screen. */
export const loginService = {
  providers(): Promise<ProvidersInfo> {
    return api.get<ProvidersInfo>('/auth/providers');
  },
  /** Which agent opened this sign-in, when it came from an authorization link. */
  authorizePreview(requestId: string): Promise<{ clientName: string; connectorName: string } | null> {
    return api.get<{ clientName: string; connectorName: string } | null>(`/auth/authorize-preview/${encodeURIComponent(requestId)}`);
  },
  localLogin(email: string): Promise<LocalLoginResponse> {
    return api.post<LocalLoginResponse>('/auth/local/login', { email });
  },
  /** Full-page redirect to the server, which bounces to the chosen SSO provider and back to `redirect` (a portal path). */
  startSso(redirect?: string, provider?: string): void {
    const q = new URLSearchParams();
    if (provider) q.set('provider', provider);
    if (redirect) q.set('redirect', redirect);
    const qs = q.toString();
    window.location.assign(qs ? `/auth/login?${qs}` : '/auth/login');
  },
};
